//=================================================
//    summary: DCP RunningPieChart 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/02 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useEffect, useRef } from 'react'
import cssRunningPieChart from './RunningPieChart.module.scss'
import ReactDOM from 'react-dom'

import { GlobalLibs, CreateJSLibs } from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false
let mintAverage = -1
let mintPercentage = -1

let mcjStageChart = null
let mcjArcCommand = null      // 動畫圓環圖
let mcjCtnCircle = null
let mintScoredCount = -1
let mintListCount = -1
let mobjFontConfig = {
    "Family": "Helvetica",
    "LighterFamily": "lighter Helvetica",
    "Size": {
        "PercentageText": 24,           // px
        "CompletedText": 10,            // px
        "CompletedOffset": 20            // px
    }
}
let mobjOriginalDimensionConfig = {
    "Width": 120,               // 繪圖區 寬
    "Height": 120,              // 繪圖區 高

    "AverageCircleRadius": 60,      // 上方圓餅圖 半徑
    "AverageCircleStroke": 10,          // 上方圓餅圖 畫筆粗
    "AverageCircleStrokeRadius": 50    // 上方圓餅圖 用畫筆的 半徑
}
// #endregion Member Variables

// #region Const
const STYLE_COLOR_PERCENTAGE_TEXT_NA = "#B3B3B3"         // Percentage 顯示 顏色
const STYLE_COLOR_PERCENTAGE_TEXT_PASSED = "#51B07A"     // Percentage 顯示 顏色
const STYLE_COLOR_PERCENTAGE_TEXT_FAILED = "#FF0000"     // Percentage 顯示 顏色
const STYLE_COLOR_PERCENTAGE_TEXT_COMPLETED = "#AAAAAA"  // Completed 顯示 顏色
const STYLE_COLOR_ARC_BG = "#B3B3B3"                     // Arc 底色
const STYLE_COLOR_ARC_FG_NA = "#B3B3B3"                  // Arc 前面 顏色
const STYLE_COLOR_ARC_FG_PASSED = "#51B07A"              // Arc 前面 顏色
const STYLE_COLOR_ARC_FG_FAILED = "#FF0000"              // Arc 前面 顏色
// #endregion Const


const COMP_NAME = "RunningPieChart"

function RunningPieChart(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init Ref
    let mrefCanvas = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefUpdatePercentageResult = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    mrefUpdatePercentageResult.current = UpdatePercentageResult
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mintAverage = -1
        mintPercentage = -1
        mintScoredCount = -1
        mintListCount = -1

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update props.Average
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect props.Average: ", props.Average)

        if (
            (typeof(props.Average) !== 'undefined') &&
            (props.Average !== null) &&
            (props.Average !== mintAverage)
            )
        {
            mintAverage = props.Average
            if (mcjArcCommand !== null)
            {
                CreateJSLibs.Instance.Tween.removeTweens(mcjArcCommand)
            }

            if (mcjCtnCircle !== null)
            {
                mcjStageChart.removeChild(mcjCtnCircle)
                mcjCtnCircle = null
            }

            mrefUpdatePercentageResult.current(props.Average)
        }
    }, [props.Average])

    // Update props.Percentage props.ScoredCount props.ListCount
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect props.Percentage: ", props.Percentage)

        if (
            (typeof(props.Percentage) !== 'undefined') &&
            (props.Percentage !== null) &&
            (props.Percentage !== mintPercentage)
            )
        {
            mintPercentage = props.Percentage
            if (mcjArcCommand !== null)
            {
                CreateJSLibs.Instance.Tween.removeTweens(mcjArcCommand)
            }
            
            mintScoredCount = props.ScoredCount
            mintListCount = props.ListCount

            if (mcjCtnCircle !== null)
            {
                mcjStageChart.removeChild(mcjCtnCircle)
                mcjCtnCircle = null
            }

            mrefUpdatePercentageResult.current(props.Percentage)
        }
    }, [props.Percentage, props.ScoredCount, props.ListCount])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            mintAverage = -1
            mintPercentage = -1
            mintScoredCount = -1
            mintListCount = -1
        }
    }, [])


    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        DrawElementOnCanvas()
    } // end of PaintedMe

    /*===========================================
    summary: 取得 Image 顯示用資料
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GetImageData () 
    {
        // console.log(COMP_NAME + ".GetImageData")
        
        // 重算 config depens on devicePixelRatio (eg. 2x for iPad Retina, 3x for iPhone 6Plus)
        let objDimensionConfig = CloneDimensionConfigOnDevicePixelRatio(mobjOriginalDimensionConfig, window.devicePixelRatio)

        let objImageData = {
            "Width": 0,
            "Height": 0,
            "PieChartBGImage": null
        } 
        // // set my dimesion (Display area)
        // let intWidth = (objDimensionConfig.Width / window.devicePixelRatio);
        // let intHeight = (objDimensionConfig.Height / window.devicePixelRatio);
        let intWidth = objDimensionConfig.Width
        let intHeight = objDimensionConfig.Height

        // console.log(COMP_NAME + ".RenderContentWrapper 1 intWidth: ", intWidth)
        // console.log(COMP_NAME + ".RenderContentWrapper 1 intHeight: ", intHeight)

        objImageData.PieChartBGImage = GenerateBGImage(intWidth, intHeight, window.devicePixelRatio, objDimensionConfig)

        if (window.devicePixelRatio !== 1)
        {
            intWidth = Math.round(intWidth / window.devicePixelRatio) + "px"
            intHeight = Math.round(intHeight / window.devicePixelRatio) + "px"
        }

        // console.log(COMP_NAME + ".RenderContentWrapper 2 intWidth: ", intWidth)
        // console.log(COMP_NAME + ".RenderContentWrapper 2 intHeight: ", intHeight)

        objImageData.Width = intWidth
        objImageData.Height = intHeight

        return objImageData
    } // end of GetImageData

    /*===========================================
    summary: 畫圖表 到 Canvas上
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function DrawElementOnCanvas ()
    {
        console.log(COMP_NAME + ".DrawElementOnCanvas")

        let objCanvas = ReactDOM.findDOMNode(mrefCanvas.current)
        mcjStageChart = new CreateJSLibs.Instance.Stage(objCanvas)

        mcjStageChart.scaleX = (1 / window.devicePixelRatio)
        mcjStageChart.scaleY = (1 / window.devicePixelRatio)

        mcjStageChart.update()

        GenerateChart()
    } // end of DrawElementOnCanvas

    /*===========================================
    summary: 取得 Clone 設定的 倍數 參數值
      param: DimensionConfigObject： 圖檔設定值
             DeviceRatio： 放大倍率

    retruns: 
    remarks: 000 Tim 2020/11/18 Create
    ===========================================*/
    function CloneDimensionConfigOnDevicePixelRatio (DimensionConfigObject, DeviceRatio)
    {
        // console.log(COMP_NAME + ".CloneDimensionConfigOnDevicePixelRatio: ", DimensionConfigObject, DeviceRatio);
        let objClone = {}

        for (let stItemKey in DimensionConfigObject)
        {
            objClone[stItemKey] = DimensionConfigObject[stItemKey] * DeviceRatio
        }

        return objClone
    } // end of CloneDimensionConfigOnDevicePixelRatio

    /*===========================================
    summary: 取得 Clone 設定的 倍數 字型參數值
      param: FontSizeConfigObject： 字型設定值
             DeviceRatio： 放大倍率

    retruns: 
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function CloneFontSizeConfigOnDevicePixelRatio (FontSizeConfigObject, DeviceRatio)
    {
        console.log(COMP_NAME + ".CloneFontSizeConfigOnDevicePixelRatio: ", FontSizeConfigObject, DeviceRatio)
        let objClone = {}

        for (let stItemKey in FontSizeConfigObject)
        {
            objClone[stItemKey] = FontSizeConfigObject[stItemKey] * DeviceRatio
        }

        return objClone
    } // end of CloneFontSizeConfigOnDevicePixelRatio

    /*===========================================
    summary: 產生 圖表
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GenerateChart ()
    {
        console.log(COMP_NAME + ".GenerateChart")

        UpdatePercentageResult(-1)
    } // end of GenerateChart

    /*===========================================
    summary: 重新整理 平均分數 圓餅圖 圖表 下方分數 與 長條圖
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function UpdatePercentageResult (Percentage)
    {
        console.log(COMP_NAME + ".UpdatePercentageResult: ", Percentage)

        // === Average圓餅圖 BEGIN ===
        mcjCtnCircle = GenerateFGCircleContainer(Percentage)
        mcjCtnCircle.x = 0
        mcjCtnCircle.y = 0
        // === Average圓餅圖 END ===
        mcjStageChart.addChild(mcjCtnCircle)
        mcjStageChart.update()
    } // end of UpdatePercentageResult

    /*===========================================
    summary: 判斷是否為 iPad non Retina
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function IsIPadNonRetina ()
    {
        console.log(COMP_NAME + ".IsIPadNonRetina")

        let blnIsIPadNonRetina = true
        if (
            (window.gSession.App.DeviceType4LogTrace === GlobalLibs.DeviceType4LogTraceEnum.iPad) &&
            (window.devicePixelRatio === 1)
            )
        {
            blnIsIPadNonRetina = true
        }
        else
        {
            blnIsIPadNonRetina = false
        }

        return blnIsIPadNonRetina
    } // end of IsIPadNonRetina

    /*===========================================
    summary: 產生 底圖 的圖片
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function GenerateBGImage (Width, Height, DeviceRatio, DimensionConfig)
    {
        // console.log(COMP_NAME + ".GenerateBGImage: ", Width, Height, DeviceRatio);

        let objCanvas = document.createElement("canvas");
        
        objCanvas.width = Width;
        objCanvas.height = Height;

        objCanvas.style.width = Math.round(Width / DeviceRatio).toString() + "px";
        objCanvas.style.height = Math.round(Height / DeviceRatio).toString() + "px";

        let cjStage = new CreateJSLibs.Instance.Stage(objCanvas);

        // === Average圓餅圖 BEGIN ===
        let cjCtnCircle = GenerateBGCircle(DimensionConfig.AverageCircleStroke, DimensionConfig.AverageCircleRadius, DimensionConfig.AverageCircleStrokeRadius);
        cjCtnCircle.x = 0;
        cjCtnCircle.y = 0;
        cjStage.addChild(cjCtnCircle);
        // === Average圓餅圖 END ===

        cjStage.update();

        return objCanvas.toDataURL(); // image base64 return
    } // end of GenerateBGImage

    /*===========================================
    summary: 產生 底圖 圓餅圖
    remarks: 000 Tim 2020/11/03 Create
    ===========================================*/
    function GenerateBGCircle (AverageCircleStroke, AverageCircleRadius, AverageCircleStrokeRadius)
    {
        // console.log(COMP_NAME + ".GenerateBGCircle")

        let cjCtnCircle = new CreateJSLibs.Instance.Container()

        // === 圓餅圖 BEGIN ===
        let cjCircle = new CreateJSLibs.Instance.Shape()
        cjCircle.graphics.beginStroke(STYLE_COLOR_ARC_BG)
        cjCircle.graphics.setStrokeStyle(AverageCircleStroke, "butt")
        cjCircle.graphics.arc(AverageCircleRadius, AverageCircleRadius, AverageCircleStrokeRadius, 0, Math.PI * 2, false)
        cjCircle.graphics.endStroke()

        cjCircle.x = 0
        cjCircle.y = 0

        cjCtnCircle.addChild(cjCircle)
        // === 圓餅圖 END ===

        return cjCtnCircle
    } // end of GenerateBGCircle

    /*===========================================
    summary: 產生 前景 圓餅圖
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function GenerateFGCircleContainer (Percentage)
    {
        console.log(COMP_NAME + ".GenerateFGCircleContainer: Percentage: ", Percentage)

        let objDimensionConfig = CloneDimensionConfigOnDevicePixelRatio(mobjOriginalDimensionConfig, window.devicePixelRatio)
        let objFontSizeConfig = CloneFontSizeConfigOnDevicePixelRatio(mobjFontConfig.Size, window.devicePixelRatio)
        let cjCtnCircle = new CreateJSLibs.Instance.Container()

        let fltPercetage = Percentage / 100 * 2 - 0.5
        let blnIsIPadNonRetina = IsIPadNonRetina()

        // === 圓餅圖 BEGIN ===
        let cjCircle = new CreateJSLibs.Instance.Shape()
        let strStrokeColor = ""
        if (Percentage === -1)
        {
            strStrokeColor = STYLE_COLOR_ARC_FG_NA
        }            
        else if (Percentage < 60)
        {
            strStrokeColor = STYLE_COLOR_ARC_FG_FAILED
        }
        else
        {
            strStrokeColor = STYLE_COLOR_ARC_FG_PASSED
        }

        cjCircle.graphics.beginStroke(strStrokeColor)
        cjCircle.graphics.setStrokeStyle(objDimensionConfig.AverageCircleStroke, "butt")

        if (blnIsIPadNonRetina)
        {
            // iPad 2, iPad Mini 不跑動畫
            cjCircle.graphics.arc(objDimensionConfig.AverageCircleRadius, objDimensionConfig.AverageCircleRadius, objDimensionConfig.AverageCircleStrokeRadius, Math.PI * -0.5, Math.PI * fltPercetage, false)
        }
        else
        {
            cjCircle.graphics.arc(objDimensionConfig.AverageCircleRadius, objDimensionConfig.AverageCircleRadius, objDimensionConfig.AverageCircleStrokeRadius, Math.PI * -0.5, Math.PI * -0.5, false)
        }

        cjCircle.x = 0
        cjCircle.y = 0
        cjCtnCircle.addChild(cjCircle)

        // 動畫
        if (!blnIsIPadNonRetina && (Percentage > 0))
        {   
            StartGame()

            mcjArcCommand = cjCircle.graphics.command
            fltPercetage = Percentage / 100 * 2 - 0.5

            // objMe = this
            // CreateJSLibs.Instance.Tween.get(mcjArcCommand).to({endAngle: Math.PI * fltPercetage}, 1000, CreateJSLibs.Instance.Ease.quadOut).call(PieChartRunEnd, [objMe], objMe)
            CreateJSLibs.Instance.Tween.get(mcjArcCommand)
                .to({endAngle: Math.PI * fltPercetage}, 1000, CreateJSLibs.Instance.Ease.quadOut)
                .call(PieChartRunEnd)
        }
        else
        {
            // 停止
            // PieChartRunEnd()
        }
        // === 圓餅圖 END ===

        // === 圓餅中間總分數 BEGIN ===
        let strPercentage = ""
        if (Percentage === -1)
        {   
            strPercentage = "N/A"
        }
        else
        {
            console.log(COMP_NAME + ".GenerateFGCircleContainer: mintScoredCount: ", mintScoredCount)
            console.log(COMP_NAME + ".GenerateFGCircleContainer: mintListCount: ", mintListCount)

            if (mintListCount > 0)
            {
                strPercentage = mintScoredCount.toString() + " / " + mintListCount.toString()
            }
            else
            {
                strPercentage = Percentage
                
                if (props.IsTeacher)
                {
                    strPercentage += "%"
                }
            }
        }
        console.log(COMP_NAME + ".GenerateFGCircleContainer: strPercentage: ", strPercentage)

        let strPercentageFontConfig = objFontSizeConfig.PercentageText + "px " + mobjFontConfig.Family
        let strPercentageTextColor = ""
        if (Percentage === -1)
        {
            strPercentageTextColor = STYLE_COLOR_PERCENTAGE_TEXT_NA
        }
        else if (Percentage < 60)
        {
            strPercentageTextColor = STYLE_COLOR_PERCENTAGE_TEXT_FAILED
        }
        else
        {
            strPercentageTextColor = STYLE_COLOR_PERCENTAGE_TEXT_PASSED
        }

        let ctPercentage = new CreateJSLibs.Instance.Text(strPercentage, strPercentageFontConfig, strPercentageTextColor)
        ctPercentage.textBaseline = "middle"
        ctPercentage.textAlign = "center"
        ctPercentage.x = objDimensionConfig.AverageCircleRadius
        ctPercentage.y = objDimensionConfig.AverageCircleRadius
        cjCtnCircle.addChild(ctPercentage)
        // === 圓餅中間總分數 END ===

        if (mintListCount > 0)
        {
            // === 圓餅中間 Completed BEGIN ===
            let strCompletedFontConfig = objFontSizeConfig.CompletedText + "px " + mobjFontConfig.Family
            let strCompletedTextColor = STYLE_COLOR_PERCENTAGE_TEXT_COMPLETED

            let ctCompleted = new CreateJSLibs.Instance.Text(window.gAppUI.LBL_Completed, strCompletedFontConfig, strCompletedTextColor)
            ctCompleted.textBaseline = "middle"
            ctCompleted.textAlign = "center"
            ctCompleted.x = objDimensionConfig.AverageCircleRadius
            ctCompleted.y = objDimensionConfig.AverageCircleRadius + objFontSizeConfig.CompletedOffset
            cjCtnCircle.addChild(ctCompleted)
            // === 圓餅中間 Completed END ===
        }

        return cjCtnCircle
    } // end of GenerateFGCircleContainer

    /*===========================================
    summary: 開始跑動畫
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function StartGame () 
    {
        console.log(COMP_NAME + ".StartGame")

        CreateJSLibs.AddTickRef(COMP_NAME, HandleTick);
        CreateJSLibs.ResumeTick()
    } // end of StartGame

    /*===========================================
    summary: 開始跑Tick
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function HandleTick (e)
    {   
        console.log(COMP_NAME + ".HandleTick")
        mcjStageChart.update()
    } // end of HandleTick 

    // /*===========================================
    // summary: 開始跑 Average動畫
    // remarks: 000 Tim 2021/11/03 Create
    // ===========================================*/
    // function PieChartRun (e)
    // {
    //     if (!CreateJSLibs.Instance.Ticker.paused)
    //     {
    //         HandleTick(e)
    //     }
    // } // end of PieChartRunBegin 

    /*===========================================
    summary: Average動畫結束
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function PieChartRunEnd (e)
    {
        console.log(COMP_NAME + ".PieChartRunEnd")

        // CreateJSLibs.Instance.Ticker.paused = true
        // CreateJSLibs.Instance.Ticker.removeEventListener("tick", PieChartRun, false)
        CreateJSLibs.PauseTick()
        CreateJSLibs.RemoveTickRef(COMP_NAME);
    } // end of PieChartRunEnd
    // #endregion Other Functions

    // #region Render
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        let objImageData = GetImageData()

        return (
            <>
                <img className={cssRunningPieChart.imgContent} width={objImageData.Width} height={objImageData.Height} src={objImageData.PieChartBGImage} alt=""/>
                <canvas ref={mrefCanvas} className={cssRunningPieChart.canvasContent} width={objImageData.Width} height={objImageData.Height}/>
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/02 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssRunningPieChart.divMain}>
                {RenderContentWrapper()}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default RunningPieChart